'use client'
import PlaceHolder from '@/assets/images/placeholder/player-1.png'
import { POPULAR_PLAYERS } from '@/graphql/globalwidget/rankings.query'
import { getImgURL } from '@/shared/utils'
import { useQuery } from '@apollo/client'
import { useState } from 'react'
import CommonNav from '../../commonNav'
import CustomLink from '../../customLink'
import MyImage from '../../myImage'

interface Player {
  oPlayer: {
    sPlayingRole: string
    oImg?: {
      sUrl: string
    }
    sFullName: string
    oSeo: {
      sSlug: string
    }
  }
  sTeam: string
  eRankType: string
}

const tabs = [
  { navItem: 'All', value: 'all' },
  { navItem: 'Batter', value: 'Batter' },
  { navItem: 'Bowler', value: 'Bowler' },
  { navItem: 'All Rounder', value: 'All rounder' }
]

function TrendingPlayers() {
  const { data } = useQuery(POPULAR_PLAYERS)

  const [filter, setFilter] = useState<string>(tabs[0]?.value)

  const handleTabChange = ({ value }: any) => {
    setFilter(value)
  }

  if (data?.getTrendingPlayers?.length === 0) return null

  const filteredPlayers =
    filter === 'all'
      ? data?.getTrendingPlayers?.slice(0, 5)
      : data?.getTrendingPlayers?.filter((player: Player) => player?.eRankType === filter)

  return (
    <div className="mb-6">
      <p className="text-lg font-bold mb-4 text-textOffWhite">Trending Players</p>
      <CommonNav
        items={tabs}
        variant={'pills'}
        asButton
        tabClassName="text-xs"
        className=" mb-6"
        onTabChange={handleTabChange}
        isActive={item => item?.value === filter}
      />
      <div>
        {filteredPlayers?.map((player: Player, index: number) => (
          <CustomLink key={index} href={`/${player?.oPlayer?.oSeo?.sSlug}`}>
            <div className="flex items-center gap-3 py-4 border-b border-tabBorder dark:last:border-b ">
              <MyImage
                src={
                  player?.oPlayer?.oImg?.sUrl ? getImgURL(player.oPlayer.oImg.sUrl) : PlaceHolder
                }
                width={48}
                height={48}
                className="aspect-square rounded-full flex-shrink-0"
                alt={player?.oPlayer?.sFullName}
              />
              <div>
                <p className="text-xs font-bold mb-2 text-textOffWhite hover:text-primary-500">
                  {player?.oPlayer?.sFullName}
                </p>
                <p className="flex items-center gap-1 text-xs text-textDselected">
                  <span>{player?.sTeam}</span>
                  <span className="w-[3px] h-[3px] rounded-full bg-textDselected"></span>
                  <span>{player?.eRankType}</span>
                </p>
              </div>
            </div>
          </CustomLink>
        ))}
      </div>
    </div>
  )
}

export default TrendingPlayers
